import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import React from 'react';

// Alert is inlined below to avoid multiple component definitions

const useStyles = makeStyles(() => {
    return {
        root: {
            width: '100%',
            '& > * + *': {
                marginTop: 8
            }
        }
    };
});

type Props = {

    /**
     * Notification object.
     */
    notification: ?Object,

    /**
     * Open notification dialog.
     */
    openNotifier: Boolean,

    /**
     * Helps in closing the dialog.
     */
    handleClose: Function,
};


export const MaterialNotifier = ({
    notification: { alertType, description },
    openNotifier,
    handleClose
}: Props) => {
    const classes = useStyles();

    return description && (
        <div className = { classes.root }>
            <Snackbar
                autoHideDuration = { 6000 }
                onClose = { handleClose }
                open = { openNotifier }>
                <MuiAlert
                    color = { alertType }
                    elevation = { 6 }
                    onClose = { handleClose }
                    severity = { alertType }
                    sx = {{ width: '100%' }}
                    variant = 'filled'>
                    {description}
                </MuiAlert>
            </Snackbar>
        </div>)
    ;
};
